import React from 'react';
import { createPortal } from 'react-dom';

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// Sin new Date: el string viene sin zona y el parseo nativo lo corre un día atrás.
const partes = (periodo) => {
  const [y, m] = String(periodo || '').slice(0, 7).split('-').map(Number);
  return { y, m };
};

// "2026-09" | "2026-09-30" → "Septiembre 2026" / "Sep 2026" / "septiembre".
export const mesLargo = (periodo) => {
  const { y, m } = partes(periodo);
  return MESES[m - 1] ? `${cap(MESES[m - 1])} ${y}` : String(periodo || '');
};
export const mesCorto = (periodo) => {
  const { y, m } = partes(periodo);
  return MESES[m - 1] ? `${cap(MESES[m - 1]).slice(0, 3)} ${y}` : String(periodo || '');
};
export const mesNombre = (periodo) => MESES[partes(periodo).m - 1] || '';

// Fecha de reporte = último día del mes → "30/09/2026".
export const fechaCorte = (periodo) => {
  const { y, m } = partes(periodo);
  if (!MESES[m - 1]) return '';
  const dia = new Date(y, m, 0).getDate();
  return `${String(dia).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y}`;
};

// "2026-09" → "2026-09-30": el periodo que espera el backend.
export const ultimoDia = (periodo) => {
  const { y, m } = partes(periodo);
  return `${y}-${String(m).padStart(2, '0')}-${String(new Date(y, m, 0).getDate()).padStart(2, '0')}`;
};

// Meses terminados, del más reciente al más viejo, para el modal de crear.
export const mesesTerminados = (cuantos = 12) => {
  const hoy = new Date();
  const out = [];
  for (let i = 1; i <= cuantos; i += 1) {
    const d = new Date(hoy.getFullYear(), hoy.getMonth() - i, 1);
    out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
  }
  return out;
};

export const money0 = (n) => '$ ' + Math.round(Number(n) || 0).toLocaleString('en-US');
export const money2 = (n) => '$ ' + (Number(n) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const entero = (n) => Math.round(Number(n) || 0).toLocaleString('en-US');

// "2026-10-02T12:15:00-06:00" → "02/10/2026 12:15".
export const fechaHora = (v) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(String(v || ''));
  return m ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}` : String(v || '');
};

export const CHIP = {
  borrador: { label: 'Borrador', bg: '#FFF6E5', fg: '#8A6D2A' },
  cerrado: { label: 'Cerrado', bg: '#E8F7FD', fg: '#0E5E80' },
  enviado: { label: 'Enviado', bg: '#E6F7EE', fg: '#1B7F4D' },
};

export const ChipEstatus = ({ estatus }) => {
  const c = CHIP[estatus] || CHIP.borrador;
  return (
    <span className="bu-chip" style={{ background: c.bg, color: c.fg }}>
      <span className="pip" style={{ background: c.fg }} />{c.label}
    </span>
  );
};

/*
 * Portalea modales y paneles a <body> para que el `position: fixed` cubra toda
 * la pantalla (mismo motivo que ModalPortal de Cartera). Envuelve en
 * `.buro-dash` para conservar los estilos scoped de buro-reportes.css.
 */
export const BuroPortal = ({ children }) => {
  if (typeof document === 'undefined') return null;
  return createPortal(<div className="buro-dash">{children}</div>, document.body);
};

// Mensaje de un error de axios, en texto para personas (nunca el JSON crudo):
// el `message` del backend (ya en español) o el primer error de validación.
export const mensajeError = (e, porDefecto) => {
  const d = e?.response?.data;
  const msg = (typeof d === 'string' ? d : d?.message) || Object.values(d?.errors || {})[0]?.[0] || '';
  if (/cliente ligado/i.test(msg)) return 'Este contrato no tiene cliente ligado: los cambios se guardan solo en este reporte.';
  return msg || porDefecto;
};

export const AVISO_SIN_CLIENTE = 'Este contrato no tiene cliente ligado: los cambios se guardan solo en este reporte';
